import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class ListUserDataService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
  ) { }

  listUserData(selectedUser : string, sectionId : string, dateAndIdOnly : boolean = false, docId : string = null) {

    // selectedUser で指定されたユーザのUserDataをリストする

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    var params = new HttpParams()
      .set('givenTo', selectedUser)
      .set('dateAndIdOnly', dateAndIdOnly.toString())
      .set('count', '1000');

    if (docId !== null){
      params = params.set('docId', docId);
    }

    var url = `${apiConfig.uri}/licence/${sectionId}/userdata`

    return this.httpClient.get(url, { params: params, headers: this.headers });
  }
}
